import Validators from './validators';
import { prepareMsg, prepare, trunc, isNumber, selectNum, memoize } from './helpers';

const REG_NUMBER_WITH_COMMA = /^[+-]?(\d+)([,][\d]+)?$/;
const REG_NUMBER_WITH_DOT = /^[-]?[\d]+([.][\d]+)?$/;

export default memoize(
	({
		even,
		odd,
		'=': equal,
		equalTo,
		'!=': diff,
		otherThan,
		'>': greater,
		greaterThan,
		'<': less,
		lessThan,
		'>=': greaterOrEqual,
		greaterThanOrEqualTo,
		'<=': lessOrEqual,
		lessThanOrEqualTo,
		message,
		msg,
		if: ifCond,
		unless,
		allowBlank,
		allowComma,
		validateEmptyValue,
	} = {}) => {
		msg = msg || message;
		equal = selectNum(equal, equalTo, allowComma);
		diff = selectNum(diff, otherThan, allowComma);
		greater = selectNum(greater, greaterThan, allowComma);
		greaterOrEqual = selectNum(greaterOrEqual, greaterThanOrEqualTo, allowComma);
		less = selectNum(less, lessThan, allowComma);
		lessOrEqual = selectNum(lessOrEqual, lessThanOrEqualTo, allowComma);

		return prepare(ifCond, unless, allowBlank, (value) => {
			let isValidNumberFormat = false;

			if (validateEmptyValue && value === '' && !allowBlank) {
				value = -1;
				isValidNumberFormat = true;
			}

			if (allowComma) {
				// Float number in response always with dot.
				value = value.replace('.', ',');
				isValidNumberFormat = REG_NUMBER_WITH_COMMA.test(value);
			} else {
				isValidNumberFormat = REG_NUMBER_WITH_DOT.test(value);
			}

			// eslint-disable-next-line
			allowComma ? (value = value.replace(',', '.')) : value;

			if (!isValidNumberFormat || !isNumber(value)) {
				return msg ? Validators.formatMessage(prepareMsg(msg, 'notANumber')) : 'notANumber';
			}
			//int case
			if (!allowComma && (+value % 1 || !/^[+-]?\d+$/.test(value))) {
				return msg ? Validators.formatMessage(prepareMsg(msg, 'notAnInteger')) : 'notAnInteger';
			}
			if (equal !== null && +value !== equal) {
				return Validators.formatMessage(prepareMsg(msg, 'equalTo', { count: equal }));
			}
			if (diff !== null && +value === diff) {
				return Validators.formatMessage(prepareMsg(msg, 'otherThan', { count: diff }));
			}
			if (greater !== null && +value <= greater) {
				return Validators.formatMessage(prepareMsg(msg, 'greaterThan', { count: greater }));
			}
			if (greaterOrEqual !== null && +value < greaterOrEqual) {
				return msg
					? Validators.formatMessage(prepareMsg(msg, 'greaterThanOrEqualTo', { count: greaterOrEqual }))
					: 'greaterThanOrEqualTo';
			}
			if (less !== null && +value >= less) {
				return Validators.formatMessage(prepareMsg(msg, 'lessThan', { count: less }));
			}
			if (lessOrEqual !== null && +value > lessOrEqual) {
				return msg
					? Validators.formatMessage(prepareMsg(msg, 'lessThanOrEqualTo', { count: lessOrEqual }))
					: 'lessThanOrEqualTo';
			}
			if (even && trunc(+value) % 2) {
				return Validators.formatMessage(prepareMsg(msg, 'even'));
			}
			if (odd && !(trunc(+value) % 2)) {
				return Validators.formatMessage(prepareMsg(msg, 'odd'));
			}
		});
	},
);
